module.exports = __webpack_public_path__ + "static/media/3.tapingAreaDesc.08b5c604.png";